const SEARCH_PREFIX           = 'SEARCH_';
export const SEARCH_PAGE_SIZE = 1000;

export const SEARCH_ACTIONS = {
  SET_TERM          : SEARCH_PREFIX + 'SET_TERM',
  SEARCH_START      : SEARCH_PREFIX + 'SEARCH_START',
  SEARCH_PROJECTS   : SEARCH_PREFIX + 'SEARCH_PROJECTS',
  SEARCH_EXPERIMENTS: SEARCH_PREFIX + 'SEARCH_EXPERIMENTS',
  SEARCH_MODELS     : SEARCH_PREFIX + 'SEARCH_MODELS',
  SEARCH_COMPLETE   : SEARCH_PREFIX + 'SEARCH_COMPLETE',
  SEARCH_ERROR      : SEARCH_PREFIX + 'SEARCH_ERROR',
  SEARCH_CLEAR      : SEARCH_PREFIX + 'SEARCH_CLEAR',
  SET_PROJECTS      : SEARCH_PREFIX + 'SET_PROJECTS',
  SET_MODELS        : SEARCH_PREFIX + 'SET_MODELS',
  SET_EXPERIMENTS   : SEARCH_PREFIX + 'SET_EXPERIMENTS',
  ACTIVATE          : SEARCH_PREFIX + 'ACTIVATE',
  DEACTIVATE        : SEARCH_PREFIX + 'DEACTIVATE'
};

export const EXPERIMENT_SEARCH_ONLY_FIELDS = ['name', 'created', 'status', 'type', 'user.name', 'id', 'company'];


